exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-header{padding-top:22px;padding-bottom:18px}.mobile-header::after{display:table;content:\"\";clear:both}.mobile-header h1{float:left;font-size:24px;font-weight:600;font-style:normal;font-stretch:normal;line-height:32px;color:#464a53}.mobile-header button{display:block;float:right;padding-top:7px;font-size:15px;line-height:1.33;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background-color:rgba(0,0,0,0);outline:none;color:#464a53}.mobile-header button span{display:inline-block;vertical-align:middle}.mobile-header button svg{display:inline-block;vertical-align:middle;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/mobile-header/style.scss
// module id = 1409
// module chunks = 58